interface DateRangePickerProps {
    value: number;
    onChange: (days: number) => void;
}

const OPTIONS = [7, 30, 90, 180];

export const DateRangePicker = ({ value, onChange }: DateRangePickerProps) => {
    return (
        <div className="inline-flex items-center gap-1 p-1 rounded-full border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
            {OPTIONS.map((days) => (
                <button
                    key={days}
                    type="button"
                    onClick={() => onChange(days)}
                    className={`px-3 py-1.5 rounded-full text-xs font-bold transition-colors ${
                        value === days
                            ? 'bg-white dark:bg-slate-700 text-slate-900 dark:text-white shadow-sm'
                            : 'text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200'
                    }`}
                >
                    {days}d
                </button>
            ))}
        </div>
    );
};
